import env from '@/config/env'
import request from '@/router/axios'

/**
 *
 * 三方资源统计
 */

// 价格配置-新增
export const addPriceConfig = (data) => {
  return request({
    url: `${env.ferryUrl}/tripartite-resource-price/save`,
    method: 'POST',
    data
  })
}

// 价格配置-删除
export const deletePriceConfig = (data) => {
  return request({
    url: `${env.ferryUrl}/tripartite-resource-price/delete/${data.id}`,
    method: 'DELETE',
    data
  })
}

// 获取价格配置列表
export const getPriceConfigList = (data) => {
  return request({
    url: `${env.ferryUrl}/tripartite-resource-price/list`,
    method: 'GET',
    data
  })
}

/**
 * 历史记录-规则记录
 * @param {*} data
 * @returns
 */
export const getPriceConfigHistory = (data) => {
  return request({
    url: `${env.ferryUrl}/tripartite-resource-price/history`,
    method: 'POST',
    data
  })
}

/**
 * 历史记录-充值记录
 * @param {*} data
 * @returns
 */
export const getRechargeHistory = (data) => {
  return request({
    url: `${env.ferryUrl}/tripartite-resource-recharge/page`,
    method: 'POST',
    data
  })
}

// 统计明细
export const getTotalPage = (data) => {
  return request({
    url: `${env.ferryUrl}/tripartite-resource/page`,
    method: 'POST',
    data
  })
}

// 汇总
export const getSum = (data) => {
  return request({
    url: `${env.ferryUrl}/tripartite-resource/sum`,
    method: 'POST',
    data
  })
}

// 查看内容
export const getContent = (params) => {
  return request({
    url: `${env.ferryUrl}/tripartite-resource/content`,
    method: 'GET',
    params
  })
}

// 统计
export const getStatistic = (params) => {
  return request({
    url: `${env.ferryUrl}/tripartite-resource/statistic`,
    method: 'GET',
    params
  })
}

// 查应用列表字典
export const getAppDic = () => {
  return request({
    url: `${env.ferryUrl}/tripartite-resource/type-enum`,
    method: 'GET'
  })
}

/**
 * 查服务商列考
 * @returns
 */
export const getSupplierList = () => {
  return request({
    url: `${env.ferryUrl}/tripartite-resource-price/supplier-list`,
    method: 'GET'
  })
}

/**
 * 修改外链
 * @param {*} data
 * @returns
 */
export const saveLinkUrl = (data) => {
  return request({
    url: `${env.ferryUrl}/tripartite-resource-price/link-url`,
    method: 'POST',
    data
  })
}

/**
 * 充值
 * @param {*} data
 * @returns
 */
export const saveRechage = (data) => {
  return request({
    url: `${env.ferryUrl}/tripartite-resource-recharge/save`,
    method: 'POST',
    data
  })
}

/**
 * 营销短信导入
 * @param {*} data
 * @returns
 */
export const batchImportSms = (data) => {
  return request({
    url: `${env.ferryUrl}/tripartite-resource/batch-import-sms`,
    method: 'POST',
    data
  })
}

/**
 * 删除导入的短信
 * @param {*} id
 * @returns
 */
export const deleteImportSms = (id) => {
  return request({
    url: `${env.ferryUrl}/tripartite-resource/batch-import-delete/${id}`,
    method: 'DELETE'
  })
}

// 获取平台停止下单的时间
export const getStopOrderTime = () => {
  return request({
    url: `${env.ferryUrl}/merchantPriceAdmin/getStopOrderTime`,
    method: 'GET'
  })
}

// 获取平台停止下单的时间
export const updateStopOrderTime = (data) => {
  return request({
    url: `${env.ferryUrl}/merchantPriceAdmin/updateStopOrderTime?stopOrderTime=${data}`,
    method: 'PUT'
  })
}
